import { render, staticRenderFns } from "./SportWatchNowButton.vue?vue&type=template&id=0498fb36&scoped=true"
import script from "./SportWatchNowButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SportWatchNowButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SportWatchNowButton.vue?vue&type=style&index=0&id=0498fb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498fb36",
  null
  
)

export default component.exports